<template>
  <div class="wrap">
      <img src="./imgs/15@3x.png" alt="">
      <div class="bt-group">
        <p>您是否对此活动感兴趣？</p>
        <div class="bt-wrap">
          <img @click="interested(false)" src="./imgs/ac2.png" alt="">
          <img @click="interested(true)" src="./imgs/ac1.png" alt="">
        </div>
      </div>
  </div>
</template>

<script>
import { Dialog } from 'vant'
import { POINT_CODE, BURY_POINT_TYPE, BEHAVIOR } from '@/libs/config'
import { buriedChannelPoint } from '@/api/common'
export default {
  mounted(){
    let params = {
      code: POINT_CODE.DY_LLB_ALL_PAGE,
      type: BURY_POINT_TYPE.PAGE,
      behavior: BEHAVIOR.VI,
    }
    console.log(params)
    buriedChannelPoint(params)
  },
  methods:{
    async interested(interested){
      // 感兴趣
      if(interested){
          Dialog.alert({
          title: '',
          theme: 'round-button',
          confirmButtonColor:'#364057',
          message: '感谢您的反馈，我们会在活动开启时及时向您推送！',
        })
        let params = {
          code: POINT_CODE.DY_LLB_GXQ_BUTTON,
          type: BURY_POINT_TYPE.PAGE,
          behavior: BEHAVIOR.CK,
        }
        console.log(params)
        await buriedChannelPoint(params)
      }else{
        Dialog.alert({
          title: '',
          theme: 'round-button',
          confirmButtonColor:'#364057',
          message: '感谢您的反馈，我们会继续优化我们的产品体验！',
        })
        let params = {
          code: POINT_CODE.DY_LLB_BGXQ_BUTTON,
          type: BURY_POINT_TYPE.PAGE,
          behavior: BEHAVIOR.CK,
        }
        console.log(params)
        await buriedChannelPoint(params)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.wrap{
  font-size:0;
  position: relative;
  img{
      width: 100%;
  }
  .bt-group{
    position: fixed;
    bottom: 0;
    display: block;
    width: 100%;
    height: 110px;
    box-sizing: border-box;
    text-align: center;
    padding: 14px 16px 26px;
    background: #FFF6E7;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #421F0A;
  }
  .bt-wrap{
    display: flex;
    justify-content: space-between;
    >img{
      margin-top: 16px;
      width: 164px;
      height: 34px;
    }
  }
}
</style>